// components/OratorsTemplate.js
import React from "react";
import { useParams } from "react-router-dom";
import {
  steven_data,
  camila_data,
  gerald_data,
  louie_data,
} from "../../assets/orators";

const oratorMap = {
  "steven-j-traub": steven_data,
  "camila-paiva-perin": camila_data,
  "gerald-c-green": gerald_data,
  "gregory-louie": louie_data,
};

const OratorsTemplate = () => {
  const { id } = useParams();
  const item = oratorMap[id];

  if (!item) {
    return (
      <h2 className="text-center mt-10 text-2xl text-red-600">
        404 - Orator not found
      </h2>
    );
  }

  return (
    <div className="container mx-auto flex flex-col items-center px-2 md:px-12">
      <div className="w-screen h-[50vh] text-center flex flex-col justify-center items-center bg-gray-900 mb-12">
        <img
          src={item.banner}
          alt={item.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* profile image */}
      <div className="absolute top-[65%] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <img
          src={item.image}
          alt={item.name}
          className="max-w-64 max-h-64 object-cover rounded-full shadow-lg bg-gray-100"
          loading="lazy"
        />
      </div>

      {/* name and intro */}
      <div className="relative mt-20 flex flex-col items-center text-center">
        <h1 className="text-3xl font-semibold">{item.name}</h1>
        <p className="text-green-400 text-lg">{item.from}</p>
        {/* <p className='text-xl text-gray-800'>{item.about}</p> */}
      </div>

      {/* full description */}
      <div className="px-2 md:px-24 my-4 md:mb-16 mb-12">
        <p className="text-lg leading-[28px] text-center">{item.about}</p>
      </div>
    </div>
  );
};

export default OratorsTemplate;
